module.exports = __webpack_public_path__ + "static/media/POPEN-BNB.5cea8a34.svg";